import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { isPlatformOwner } from '../utils/authUser';
import LoadingSpinner from './LoadingSpinner';

const PlatformRoute: React.FC = () => {
  const { isAuthenticated, loading, user } = useAuth();

  if (loading) {
    return <LoadingSpinner />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!isPlatformOwner(user)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
};

export default PlatformRoute;
